var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMontenegro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 10.5087 29.2332 5.66409 25.0179 2.78265H6.98206C2.76687 5.66409 0 10.5087 0 16C0 21.4915 2.76687 26.336 6.98206 29.2174H25.0179C29.2332 26.336 32 21.4915 32 16Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5212 11.826H19.4777V9.04341L18.0864 9.73904L15.9995 7.6521L13.9125 9.73904L12.5212 9.04341V11.826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2606 16H18.7837C18.9201 15.7641 18.9993 15.4912 18.9993 15.1992C18.9993 14.3125 18.2805 13.5938 17.394 13.5938C16.7814 13.5938 16.2494 13.9371 15.9787 14.4414C15.708 13.937 15.176 13.5938 14.5635 13.5938C13.6769 13.5938 12.9581 14.3125 12.9581 15.1992C12.9581 15.4912 13.0375 15.7642 13.1737 16H9.73877C9.73877 17.0639 10.6655 17.9264 11.7293 17.9264H11.6652C11.6652 18.7991 12.2456 19.5359 13.0415 19.7726L11.4779 21.3363L12.9536 22.812L15.0469 20.7187C15.1289 20.7487 15.2137 20.7727 15.3014 20.7892L14.0365 23.6452C14.6426 23.8917 15.3051 24.0285 15.9998 24.0285C16.6944 24.0285 17.3568 23.8917 17.963 23.6452L16.6981 20.7892C16.7858 20.7728 16.8706 20.7487 16.9525 20.7187L19.0458 22.812L20.5215 21.3363L18.9578 19.7727C19.7536 19.5359 20.3341 18.7991 20.3341 17.9264H20.2699C21.3339 17.9264 22.2606 17.0639 22.2606 16V16Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 17.0435L13.739 18.0869V20.1739L15.9999 21.5651L18.2607 20.1739V18.0869L15.9999 17.0435Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.739 16H18.2607V18.7826H13.739V16Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontenegro);
export default __webpack_public_path__ + "static/media/montenegro.0402298c.svg";
export { ForwardRef as ReactComponent };